import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';

const BookAMeeting = () => {
  
  useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
    head.appendChild(script);
    
    return () => {
      head.removeChild(script);
    }
  }, []);

  return (
    <Container className="min-vh-100 mt-5">
      <h1>Book a Meeting</h1>
      <p className="lead">Schedule a meeting with our expert team.</p>
      <div 
        className="calendly-inline-widget" 
        data-url="https://calendly.com/deepstonecapital?hide_gdpr_banner=1&background_color=323234&text_color=ffffff&primary_color=fce4a6" 
        style={{ height: '42em'}}
      ></div>
    </Container>
  );
};

export default BookAMeeting;
